<template>
    <v-dialog v-model="dialog" max-width="600" transition="dialog-bottom-transition" @keydown.esc="cancel">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark :disabled="loading" @click="cancel">
                    <v-icon large>close</v-icon>
                </v-btn>
                <v-toolbar-title>Comments</v-toolbar-title>
            </v-toolbar>
            <v-form ref="editForm" v-model="editValid">  
                <v-layout column pa-3>                                                
                    <v-flex xs12>
                        <v-textarea label="Safety Comments" auto-grow clearable counter="5000" outline v-model="editSafety" :rules="[rules.maxFiveThousandCharacters]"></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                        <v-textarea label="Quality Comments" auto-grow clearable counter="5000" outline v-model="editQuality" :rules="[rules.maxFiveThousandCharacters]"></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                        <v-textarea label="General Comments" auto-grow clearable counter="5000" outline v-model="editGeneral" :rules="[rules.maxFiveThousandCharacters]"></v-textarea>
                    </v-flex>
                </v-layout>
            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="save" :loading="loading" color="primary" :disabled="loading || !editable || !editValid">Save</v-btn>
                <v-btn @click="cancel" :disabled="loading" color="error">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import validationRules from "@/helpers/validationrules";

export default {
    props: {
        safety: {
            type: String,
            required: false
        },
        quality: {
            type: String,
            required: false
        },
        general: {
            type: String,
            required: false
        },
        editable: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            rules: validationRules.rules,
            dialog: true,
            loading: false,
            editSafety: this.safety,
            editQuality: this.quality,
            editGeneral: this.general,
            editValid: true
        }
    },
    watch: {
        dialog(val) {
            if (!val) {
                this.$emit("cancel");
            }
        }
    },
    methods: {
        cancel() {
            this.$refs.editForm.reset();
            this.$emit("cancel");
        },
        save() {            
            this.$emit("save", { safety: this.editSafety, quality: this.editQuality, general: this.editGeneral });
        },
    },
    created() {
    }
}
</script>
